import InboomaBaseModel from './InboomaBaseModel';

export default InboomaBaseModel.extend({

    urlRoot : '/facility_slots',

    defaults : {
      id : "",
    },

    _rbac : {
      "admin" : {
        "read" : true,
        "write" : true,
        "edit" : true,
        "edit-status" : true,
        "remove" : true
      },
      "user" : {
        "read" : true,
        "write" : false,
        "edit" : false,
        "edit-status" : false,
        "remove" : false,
      },
      "garage-staff" : {
        "read" : true,
        "write" : false,
        "edit" : false,
        "edit-status" : false,
        "remove" : false,
      },
      "manager" : {
        "read" : true,
        "write" : false,
        "edit" : false,
        "edit-status" : true,
        "remove" : false
      },
      "booking-manager" : {
        "read" : false,
        "write" : false,
        "edit" : false,
        "edit-status" : false,
        "remove" : false
      }
    },

});